import React from "react";
import AdminCategories from "../../../components/admin/categories/admin-categories";
import AdminTemplate from "../../../templates/admin-template";

const AdminCategoriesPage = () => {
  return (
    <AdminTemplate>
      <AdminCategories />
    </AdminTemplate>
  );
};

export default AdminCategoriesPage;
